module.exports = __webpack_public_path__ + "static/story_icon-54b7e7aef306a04127f4ded5e3719557.png";